import getStore from '../store/store';

export function getShouldRenderCommandCenterPlaceholder(): boolean {
    return getStore().shouldRenderCommandCenterPlaceholder;
}
